<template>
  <v-app>
    <notifyWrapper/>
    <RefreshAppAlert />
    <v-main class="layout--full-page">
      <div class="header--full-page d-flex align-center px-5"
          style="width: 100%">
          <img
            style="max-width:150px; padding:10px;"
            :src="logoUrl"
          />
        <v-spacer/>
        <div class="justify-end">
          <lang-switcher/>
        </div>
      </div>
      <slot/>
      <v-container>
        <dr-layout-placeholder :model="{$ID:'pl4'+this.$route.name, Name:'Main'}"></dr-layout-placeholder>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import LangSwitcher from '@/components/LangSwitcher'
import NotifyWrapper from '@/components/NotifyWrapper'
import inputMixin from '@it-enterprise/web-app-common/src/mixins/input-mixin'
import layoutMixin from '@it-enterprise/web-app-common/src/mixins/layout-mixin'
import RefreshAppAlert from '@/components/RefreshAppAlert'
export default {
  name: 'FullPageLayout',
  mixins: [inputMixin, layoutMixin],
  components: {
    LangSwitcher,
    NotifyWrapper,
    RefreshAppAlert
  }
}
</script>

<style scoped>
  .layout--full-page {
    background: url(../assets/full-page-bg.svg) center bottom/cover no-repeat;
  }

  .header--full-page {
    position: fixed;
  }
</style>
